import React from 'react';
import { motion } from 'framer-motion';
import { KeyIcon, SparklesIcon, ShieldIcon, WalletIcon, HeartPulseIcon, TrophyIcon } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: KeyIcon,
    title: 'DIAGNÓSTICO',
    desc: 'Identificá qué puertas están abiertas en tu hogar y tu vida',
    bullets: ['Mapa de fugas', 'Evaluación de ambiente', 'Prioridades claras']
  }, {
    icon: SparklesIcon,
    title: 'LIMPIEZA',
    desc: 'Cerrá lo que drena energía, dinero y paz',
    bullets: ['Protocolo de cierre', 'Limpieza física y simbólica', 'Orden mínimo viable']
  }, {
    icon: ShieldIcon,
    title: 'BLINDAJE',
    desc: 'Protegé tu hogar y tus límites',
    bullets: ['Protección activa del espacio', 'Límites con convivientes', 'Ambiente que sostiene']
  }, {
    icon: WalletIcon,
    title: 'DESBLOQUEO FINANCIERO',
    desc: 'Cortá las fugas de dinero y activá el flujo',
    bullets: ['Detección de fugas', 'Administración simple', 'Mentalidad de provisión']
  }, {
    icon: HeartPulseIcon,
    title: 'SALUD Y VITALIDAD',
    desc: 'Recuperá el sueño, bajá la ansiedad, fortalecé el cuerpo',
    bullets: ['Protocolo de sueño', 'Manejo de ansiedad', 'Energía sostenida']
  }, {
    icon: TrophyIcon,
    title: 'SOSTENIMIENTO',
    desc: 'Automatizá los hábitos para no volver atrás',
    bullets: ['Sistema anti-retroceso', 'Hábitos automáticos', 'Victoria sostenida']
  }];
  return <section className="py-12 md:py-32 px-4 bg-primary-bg relative" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-10 md:mb-20" data-id="element-128">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-129">
            El Método: 6 Pasos Para Restaurar Tu Vida
          </h2>
          <div className="divider-gold mx-auto max-w-md" data-id="element-130" />
        </motion.div>

        {/* Mobile: Simple stacked cards. Desktop: Timeline */}
        <div className="relative" data-id="element-131">
          {/* Vertical Line — hidden on mobile, visible on md+ */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gold/30 -translate-x-1/2" data-id="element-132" />

          {/* Mobile: simple vertical list */}
          <div className="flex flex-col gap-4 md:hidden" data-id="element-133">
            {steps.map((step, idx) => {
            const Icon = step.icon;
            return <div key={idx} className="bg-card-bg p-4 rounded-xl border border-border-gold shadow-sm" data-id="element-134">
                  <div className="flex items-center gap-3 mb-2" data-id="element-135">
                    <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0" data-id="element-136">
                      <Icon className="w-5 h-5 text-gold" data-id="element-137" />
                    </div>
                    <div data-id="element-138">
                      <span className="text-gold font-bold tracking-widest text-[10px] block" data-id="element-139">
                        PASO {idx + 1}
                      </span>
                      <h3 className="font-heading text-base font-bold text-text-primary" data-id="element-140">
                        {step.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-text-secondary font-body-serif text-sm mb-2" data-id="element-141">
                    {step.desc}
                  </p>
                  <ul className="space-y-1" data-id="element-142">
                    {step.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-center text-xs text-text-secondary font-medium" data-id="element-143">
                        <span className="w-1.5 h-1.5 rounded-full bg-gold mr-2 shrink-0" data-id="element-144" />
                        {bullet}
                      </li>)}
                  </ul>
                </div>;
          })}
          </div>

          {/* Desktop: Timeline layout */}
          <div className="hidden md:block space-y-24" data-id="element-145">
            {steps.map((step, idx) => {
            const isEven = idx % 2 === 0;
            const Icon = step.icon;
            return <div key={idx} className={`relative flex flex-row items-center gap-8 ${isEven ? 'flex-row-reverse' : ''}`} data-id="element-146">
                  <div className="absolute left-1/2 w-14 h-14 rounded-full bg-card-bg border-2 border-gold flex items-center justify-center z-10 -translate-x-1/2 shadow-md" data-id="element-147">
                    <Icon className="w-6 h-6 text-gold" data-id="element-148" />
                  </div>
                  <div className={`w-1/2 ${isEven ? 'pl-16' : 'pr-16 text-right'}`} data-id="element-149">
                    <div className="bg-card-bg p-8 rounded-2xl border border-border-gold shadow-sm hover:shadow-md transition-shadow" data-id="element-150">
                      <span className="text-gold font-bold tracking-widest text-sm mb-2 block" data-id="element-151">
                        PASO {idx + 1}
                      </span>
                      <h3 className="font-heading text-2xl font-bold text-text-primary mb-3" data-id="element-152">
                        {step.title}
                      </h3>
                      <p className="text-text-secondary font-body-serif text-lg mb-4" data-id="element-153">
                        {step.desc}
                      </p>
                      <ul className={`space-y-2 ${isEven ? '' : 'flex flex-col items-end'}`} data-id="element-154">
                        {step.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-center text-sm text-text-secondary font-medium" data-id="element-155">
                            <span className="w-1.5 h-1.5 rounded-full bg-gold mr-2" data-id="element-156" />
                            {bullet}
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}